export default __webpack_public_path__ + "static/media/ASA LOGO ONLY.c5ec6fe9.png";